import ReactDOM from "react-dom";
import React from "react";

import * as SmartDrawings from "../../smartDrawings";
import { ModelApi } from "../../api/modelApi";
import * as ColorUtils from "./colorUtils";
import ColorGradientUi from "./colorGradient";

export class MeasurementDataPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, container: any, options?: any) {
        super(container, "SmartDrawings-Panel-MeasurementData", "Measurement data", options);
        this.viewer = viewer;
        this.container.classList.add("color-legend-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    async setVisible(show: boolean) {
        super.setVisible(show);
        if (this.viewer != null) {
            this.viewer.clearThemingColors(null);
            this.viewer.showAll();
        }
        if (show) {
            const { data } = await ModelApi.getMeasurementDataRanges();

            // This userFunction is given as a string as js minification will otherwise garble it.
            const roomIdToDbId = await (this.viewer.model as any).getPropertyDb().executeUserFunction(
                `function userFunction(pdb) {
                let nameId = null;
                pdb.enumAttributes((i, attrDef, attrRaw) => {
                    if (attrDef.category === "IFC" && attrDef.displayName === "NAME") {
                        nameId = i;
                        return true;
                    }
                });

                if (nameId == null) {
                    return null;
                }

                const roomIdToDbId = {};

                pdb.enumObjects(dbId => {

                    // For each part, iterate over their properties.
                    pdb.enumObjectProperties(dbId, (attrId, valId) => {
                        if (attrId === nameId) {
                            const value = pdb.getAttrValue(attrId, valId);
                            roomIdToDbId[value] = dbId;
                            return true;
                        }
                    });
                });

                return roomIdToDbId;
            }`
            );

            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<ColorGradientUi viewer={this.viewer} ranges={data as SmartDrawings.RangeColorSchemes} roomIdToDbId={roomIdToDbId}/>, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }
}

